export default __webpack_public_path__ + "static/media/mobile_order.a3138121.png";